module.exports = __webpack_public_path__ + "static/media/login-img.5d064837.png";